import React from 'react'

import BulkUpdateForm from './BulkUpdateForm'

import Modal from 'Components/Modal'

const BulkUpdateModal = ({
  showModal,
  removeModal,
  ticketsToUpdate,
  clients,
  assignees,
  regionStatusNames,
  bulkUpdatePath,
  onHoldStatusesId,
  resolvedStatusesId,
  assigneesQueues,
  queuesAssignees,
  queues,
  priorities,
  ticketTypes
}) => (
  <div>
    <Modal
      showModal={showModal}
      title="Update Tickets"
      removeModal={() => removeModal()}
      largeModal
    >
      <BulkUpdateForm
        ticketsSelectedToUpdate={ticketsToUpdate}
        clients={clients}
        assignees={assignees}
        regionStatusNames={regionStatusNames}
        bulkUpdatePath={bulkUpdatePath}
        onHoldStatusesId={onHoldStatusesId}
        resolvedStatusesId={resolvedStatusesId}
        assigneesQueues={assigneesQueues}
        removeModal={removeModal}
        queuesAssignees={queuesAssignees}
        queues={queues}
        priorities={priorities}
        ticketTypes={ticketTypes}
      />
    </Modal>
  </div>
)

export default BulkUpdateModal
